import request from '@/utils/request'
import requestDownload from '@/utils/requestDownload'
import config from '@/config'
export default {
  getStatisticsRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetStatisticsRain', { params })
  },
  getAdcd (params) {
    return request.get(config.ApiYJ + '/Base/AdcdExcept', { params })
  },
  // 水库水位
  getStatisticsReservoirWater (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetStatisticsReservoirWater', { params })
  },
  // 河道水位
  getStatisticsRiverWater (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetStatisticsRiverWater', { params })
  },
  // 时段雨量
  getHourlyRainfallInfo (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetHourlyRainfallInfo', { params })
  },
  // 日雨量
  getDailyRainfallInfo (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetDailyRainfallInfo', { params })
  },
  // 月雨量
  getMonthlyRainfall (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetMonthlyRainfall', { params })
  },
  // 年雨量
  getYearlyRainfall (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetYearlyRainfall', { params })
  },
  // 综合雨水情（所有，江河，水库）
  getSyntheticalWaterAndRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetSyntheticalWaterAndRain', { params })
  },
  // 综合雨水情（雨量）
  getSyntheticalRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetSyntheticalRain', { params })
  },
  // 单个视频地址
  getVideoMonitorUrl (params) {
    return request.get(config.ApiYJ + '/HydrologyCenter/GetVideoMonitorUrl', { params })
  },
  // 视频监控所有视频地址
  getMonitorStations () {
    return request.get(config.ApiYJ + '/HydrologyCenter/GetMonitorStations')
  },
  // 导出
  // 实时雨情导出
  exportRealTimeRain (params) {
    return request.post(config.ApiYJ + '/Export/RealTimeRainExport', params)
  },
  // 河道水情导出
  exportRiverWater (params) {
    return request.post(config.ApiYJ + '/Export/RiverWaterExport', params)
  },
  // 水库水情导出
  exportReservoirWater (params) {
    return request.post(config.ApiYJ + '/Export/ReservoirWaterExport', params)
  },
  // 雨量统计_时段雨量导出
  exportRainStatisHourly (params) {
    return request.post(config.ApiYJ + '/Export/RainStatisHourlyExport', params)
  },
  // 雨量统计_日雨量导出
  exportRainStatisDaily (params) {
    return request.post(config.ApiYJ + '/Export/RainStatisDailyExport', params)
  },
  // 雨量统计_月雨量导出
  exportRainStatisMonthly (params) {
    return request.post(config.ApiYJ + '/Export/RainStatisMonthlyExport', params)
  },
  // 雨量统计_年雨量导出
  exportRainStatisYearly (params) {
    return request.post(config.ApiYJ + '/Export/RainStatisYearlyExport', params)
  },
  // 获取测站详情
  getRainWaterTotal (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetRainWaterTotal', { params })
  },
  // 获取测站详情
  getRainWaterMinutesTotal (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetRainWaterMinutesTotal', { params })
  },
  // 获取全区降雨量统计信息
  getAllRainfall (params) {
    return request.get(config.ApiYJ + '/RainWater/region_rainfall_statistics', { params })
  },
  // 导出
  exportAllRainfall (params) {
    return request.post(config.ApiYJ + '/Export/DistrictrainExport', params)
  },
  getRainWaterReport (params) {
    return request.get(config.ApiYJ + '/RainWater/GetRainWaterReport', { params })
  },
  getRainWaterReportExport (params) {
    return requestDownload.get(config.ApiYJ + '/RainWater/GetRainWaterReportExport', { params })
  }
}
